<template>

  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead">
      <h1>Kısa Mesaj Geçmişi</h1>
      <el-button-group class="float-right">
        <router-link tag="button" class="el-button YeniBtn el-button--small"
                     to="/iletisim/sms"> Mesaj Gönder
        </router-link>
        <router-link tag="button" class="el-button YeniBtn el-button--small"
                     to="/iletisim/sms/bildirim"> Bildirim Merkezi
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="19">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            :data="tableData.filter(data => !search || data.icerik.toLowerCase().includes(search.toLowerCase()) || data.telefon.toLowerCase().includes(search.toLowerCase()))"
            class="golgetable pt-0"
            width="100%"
            :height="Height"
            show-summary
            :summary-method="TableFooter"
            fixed>

            <el-table-column
              label="Zaman"
              prop="zaman"
              width="200">
            </el-table-column>
            <el-table-column
              label="Telefon"
              prop="telefon"
              width="120">
            </el-table-column>
            <el-table-column
              label="Durum"
              prop="durum"
              width="100">
            </el-table-column>
            <el-table-column
              label="Kredi"
              prop="kredi"
              width="150">
            </el-table-column>
            <el-table-column
              label="İçerik"
              prop="icerik">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="medium"
                  :placeholder="Sayfa.Arama"/>
              </template>

            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="5">
          <el-collapse class="Filtre" v-model="FiltreCollapse">
            <el-collapse-item :title="Sayfa.FiltreAdi" name="1">

              <el-form :rules="FormHata" :model="Form"
                       @submit.prevent.native="Getir"
                       ref="FiltreForm">

                <el-form-item label="Site / Bina" prop="Bina_id">
                  <el-select v-model="Form.Bina_id" filterable clearable>
                    <el-option-group
                      label="Site Listesi">
                      <el-option
                        v-for="item in Siteler"
                        :key="item.id"
                        :label="item.Adi"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                    <el-option-group
                      label="Bina Listesi">
                      <el-option
                        v-for="item in Binalar"
                        :key="item.id"
                        :label="item.Adi"
                        :value="item.id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>


                <el-form-item label="Tarihi Aralığı" prop="Tarih">
                  <el-date-picker
                    v-model="Form.Tarih"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Başlangıç Tarihi"
                    end-placeholder="Bitiş Tarihi"
                    format="dd.MM.yyyy"
                  >
                  </el-date-picker>
                </el-form-item>


                <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                           icon="el-icon-check">Mesajları Getir
                </el-button>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: false,
      FiltreCollapse: '1',
      search: null,
      Height: null,
      Sayfa: {
        Adi: 'Mesaj Filtreleme',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
        Arama: ''
      },
      Form: {
        Bina_id: null,
        Tarih: [],
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      Binalar: [],
      Siteler: [],
      tableData: [],
      tableDisplay: false,
      AltToplam: 0
    }
  },
  methods: {
    Getir() {
      this.lo = true;
      this.$store.dispatch("Post", {
        ...this.Form,
        path: 'iletisim/sms/gecmis'
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {

            this.tableData = response.Data
            this.AltToplam = response.AltToplam
            this.Height = window.innerHeight - 100
            if (this.tableData) this.tableDisplay = true

            this.$message.info(response.Mesaj);

          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    TableFooter() {
      const sums = [];

      sums[3] = this.AltToplam;


      return sums;
    },
    SayfaYukle() {
      this.tableData = [];
      this.tableDisplay = false;
      this.$store.dispatch("Get", {path: 'yonetim/bina'})
        .then(response => {
          if (response.Durum === 'OK') {

            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'yonetim/site'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  },
  created() {
    var Gun = new Date();
    var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Form.Tarih[0] = Gun;
    this.Form.Tarih[1] = AySonu;
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Iletisim/sms/gecmis.vue